var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"setType11Template"},[_c('el-form',{attrs:{"model":_vm.ruleForm,"label-width":"160px"}},[_c('textBefore',{attrs:{"ruleForm":_vm.ruleForm}}),_c('textAfter',{attrs:{"ruleForm":_vm.ruleForm}}),_c('colourConfig',{attrs:{"ruleForm":_vm.ruleForm}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }